import {Component} from '@angular/core';
import {SessionService} from '../../shared/service/session.service';
import {PermissionBasedEntity} from './model/permission-based-entity.model';

/**
 * Super class for enabling authorzation in the UI.
 */

@Component({
    template: '<div></div>',
    standalone: false
})
export class AuthorizationComponent extends PermissionBasedEntity {

  constructor(sessionService: SessionService) {
    super(sessionService, '', []);
  }

  setAuthorization(resource: string, rights: string[]) {
    this.resource = resource;
    this.rights = new Map();
    for (const right of rights) {
      this.rights.set(right, false);
    }
    this.determineRights(this.sessionService.getCurrentUser().roles);
    this.determineVisibility();
  }
}
